<script>
import InlineSvg from 'vue-inline-svg'
import _ from 'lodash'
import design from '@design'

export default {
  components: { InlineSvg },
  props: {
    name: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
    fileExtension: {
      type: String,
      default: '',
    },
    skipFilter: {
      type: Boolean,
    },
  },
  computed: {
    getExtensionFontSize() {
      if (this.fileExtension.length > 3) {
        return '8px'
      }
      return '10px'
    },

    getFileName() {
      const fileNames = {
        Awards: 'Trophy',
      }

      return _.get(fileNames, this.name, this.name)
    },
  },
  methods: {
    getColorFill(color) {
      const colorFills = {
        primary: design['primary-blue'],
        slate: design['primary-slate'],
        orange: design['secondary-orange'],
        red: design['secondary-red'],
        blue: design['secondary-light-blue'],
        green: design['secondary-green'],
        white: design.white,
        gray: design.gray,
        darkGray: design['dark-gray'],
        lightGray: design['light-gray'],
      }

      return colorFills[color]
    },
  },
}
</script>

<template>
  <div :class="$style.iconContainer">
    <InlineSvg :src="require(`@assets/icons/${getFileName}.svg`)" :style="{ color: getColorFill(iconColor) }" />
    <span
      v-if="fileExtension"
      :class="{
        [$style.fileExtensionText]: true,
      }"
      :style="{ 'font-size': getExtensionFontSize }">
      {{ fileExtension }}
    </span>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.iconContainer {
  position: relative;
  display: inline-block;
  height: fit-content;
}

.fileExtensionText {
  position: absolute;
  bottom: 15%;
  left: 50%;
  font-weight: bold;
  transform: translateX(-50%);
}
</style>
